import type { ReactNode } from "react";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface FinanceWarningBannerProps {
  title?: string;
  children: ReactNode;
}

export default function FinanceWarningBanner({
  title = "Some results are incomplete",
  children,
}: FinanceWarningBannerProps) {
  return (
    <div className="flex gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 text-amber-900">
      <ExclamationTriangleIcon className="h-5 w-5 shrink-0" aria-hidden />
      <div>
        <p className="text-sm font-semibold">{title}</p>
        <div className="mt-1 text-sm">{children}</div>
      </div>
    </div>
  );
}
